module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "blog_bar"
  }, [_vm._l((_vm.props), function(blogItem, i) {
    return (i <= _vm.pages) ? _c('div', {
      staticClass: "blog_bar_lists clearfix"
    }, [_c('div', {
      staticClass: "blog_barleft"
    }, [_c('h2', {
      staticClass: "blog_title"
    }, [_c('router-link', {
      attrs: {
        "to": "/blog-post/" + blogItem.slug
      },
      domProps: {
        "innerHTML": _vm._s(blogItem.title.rendered)
      }
    })], 1), _c('h3', {
      staticClass: "blog_date_bar"
    }, [_c('span', {
      staticClass: "date",
      domProps: {
        "innerHTML": _vm._s("<span>" + blogItem.date.slice(5, 7) + "</span>/<span>" + blogItem.date.slice(8, 10) + "</span>/<span>" + blogItem.date.slice(0, 4) + "</span>")
      }
    })]), (blogItem.excerpt) ? _c('div', {
      staticClass: "blog_excrept_content",
      domProps: {
        "innerHTML": _vm._s(blogItem.excerpt.rendered)
      }
    }) : _vm._e(), _c('div', {
      staticClass: "blog_readmore"
    }, [_c('router-link', {
      attrs: {
        "to": "/blog-post/" + blogItem.slug
      }
    }, [_vm._v(" Read More ...               ")])], 1)]), (blogItem.better_featured_image) ? _c('div', {
      staticClass: "blog_img"
    }, [_c('img', {
      attrs: {
        "src": blogItem.better_featured_image.source_url
      }
    })]) : _vm._e()]) : _vm._e()
  }), _c('div', {
    staticClass: "custom-repeater-blog__loader"
  }, [_c('div', {
    staticClass: "custom-repeater-blog__load",
    on: {
      "click": function($event) {
        _vm.pages = _vm.pages + 2
      }
    }
  }, [_vm._v("Load Older Posts -->")])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7cbb960","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/blog-lists/blog-lists.pug
// module id = 720
// module chunks = 1